import clsx from 'clsx'
import React, { ReactElement } from 'react'

import s from './styles.module.scss'

export const TagListItem = ({
  className,
  icon,
  label,
}: {
  label: string | ReactElement
  className?: string[] | string
  icon?: ReactElement
}) => {
  return (
    <div
      className={clsx(
        s.tag,
        ...(Array.isArray(className) ? className : [className]),
      )}
    >
      {icon && icon}
      <span>{label}</span>
    </div>
  )
}
